import { getPreferredLanguage } from './languages.js';

// T469 — which language to offer, and why.
//
// His words: "trebuie tot timpul să văd în ce limbă să generez". The
// selector defaulted to whatever he used last, and his corpus is 835 Danish
// adverts to 838 English ones — so that default was a coin flip, and the
// only way to beat it was to open the posting and read it himself.
//
// Order of authority, strongest first:
//   1. the draft that already exists — he decided this one already;
//   2. the language the ADVERT is written in;
//   3. his sticky last choice, which is all there was before.
//
// The reason travels with the answer, because a default that changes by
// itself has to say why or it just looks like a bug.
export function languageDefault({ existingLanguage, postingLanguage } = {}) {
  if (existingLanguage) return { code: existingLanguage, reason: 'draft' };
  if (postingLanguage) return { code: postingLanguage, reason: 'posting' };
  return { code: getPreferredLanguage(), reason: 'preference' };
}

export function languageReasonText(reason, code) {
  if (reason === 'posting') return `this posting is written in ${code.toUpperCase()}`;
  if (reason === 'draft') return 'matching the draft you already have';
  return 'your last choice — this posting’s language could not be determined';
}
